import { Wall } from "../Utils/Types";
import { WallUtils } from "../Utils/Wall/WallUtils";

export const wallMidY = (wall: Wall): number => (wall.start.y + wall.end.y) / 2;

export function getWallAngle(wall: Wall): number {
    return typeof wall.angleRad === "number"
        ? wall.angleRad
        : Math.atan2(
            wall.end.y - wall.start.y,
            wall.end.x - wall.start.x
        );
}

export function angleDiff(a: number, b: number): number {
    return Math.abs(Math.atan2(Math.sin(a - b), Math.cos(a - b)));
}

export function getFloorWall(walls: Wall[]): Wall | undefined {
    if (walls.length < 2) return undefined;
    return walls.reduce((best, current) => wallMidY(current) > wallMidY(best) ? current : best);
}

export function perpendicularScore(reference: Wall, candidate: Wall): number {
    const refAngle = getWallAngle(reference);
    const candAngle = getWallAngle(candidate);

    const targetA = refAngle + Math.PI / 2;
    const targetB = refAngle - Math.PI / 2;

    return Math.min(
        angleDiff(candAngle, targetA),
        angleDiff(candAngle, targetB)
    );
}

export function getMostPerpendicularWall(walls: Wall[]): Wall | null {
    if (walls.length < 2) return null;

    const floorWall = getFloorWall(walls);
    if (!floorWall) return null;

    const parent = WallUtils.getWallParent(floorWall, walls)!;
    const child = WallUtils.getWallChild(floorWall, walls)!;

    const parentScore = perpendicularScore(floorWall, parent);
    const childScore = perpendicularScore(floorWall, child);

    if (parentScore < childScore) return parent;
    if (childScore < parentScore) return child;

    // égalité → premier dans la liste
    const parentIndex = walls.findIndex((w) => w.wallId === parent.wallId);
    const childIndex = walls.findIndex((w) => w.wallId === child.wallId);

    return parentIndex < childIndex ? parent : child;
}